/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Cap_TitleInputs */



/**
* | output |
* | --- |
* | "Still going?" |
*
* @param {Meeting_Offline_Cap_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_cap_title = /** @type {((inputs?: Meeting_Offline_Cap_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Cap_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nog altijd bezig?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toujours en cours ?")
	return /** @type {LocalizedString} */ ("Still going?")
});